
const ProcurementRoutes = [
    {
        path: '',
        name: 'procurement-index',
        component: () => import("@/views/overview.vue")
    },
    {
        path: 'ai',
        name: 'ai-procurement',
        component: () => import("@/components/procurement/ai/suggestions.vue")
    },
    {
        path: 'form',
        name: 'form-procurement',
        component: () => import("@/components/procurement/form.vue")
    }
];
export default ProcurementRoutes